import React from "react";
import styles from "./terms-and-conditions.module.scss";
import { SeoComponent } from "../../components/seo/Seo.component";

export const TermsAndConditions: React.FC = () => {
  return (
    <div className={styles["terms-and-conditions"]}>
      <SeoComponent
        title="Terms and Conditions | Volumetric"
        description="Review the Terms and Conditions governing your use of the Volumetric Labs website and services."
      />
      <h1 className={styles["section-title"]}>Terms and Conditions</h1>

      <div className={styles["content"]}>
        <p>Last updated: November 28, 2025</p>

        <h2>1. Introduction</h2>
        <p>
          Welcome to Volumetric Labs. These Terms and Conditions ("Terms")
          govern your use of our website located at volumetric.io (the
          "Service") operated by Volumetric Labs ("us", "we", or "our").
        </p>
        <p>
          By accessing or using the Service, you agree to be bound by these
          Terms. If you disagree with any part of the terms, then you may not
          access the Service.
        </p>

        <h2>2. Intellectual Property</h2>
        <p>
          The Service and its original content, features, and functionality are
          and will remain the exclusive property of Volumetric Labs and its
          licensors. The Service is protected by copyright, trademark, and other
          laws of both the Netherlands and foreign countries. Our trademarks and
          trade dress may not be used in connection with any product or service
          without the prior written consent of Volumetric Labs.
        </p>

        <h2>3. Links to Other Web Sites</h2>
        <p>
          Our Service may contain links to third-party web sites or services
          that are not owned or controlled by Volumetric Labs.
        </p>
        <p>
          Volumetric Labs has no control over, and assumes no responsibility
          for, the content, privacy policies, or practices of any third-party
          web sites or services. You further acknowledge and agree that
          Volumetric Labs shall not be responsible or liable, directly or
          indirectly, for any damage or loss caused or alleged to be caused by
          or in connection with use of or reliance on any such content, goods or
          services available on or through any such web sites or services.
        </p>

        <h2>4. Limitation of Liability</h2>
        <p>
          In no event shall Volumetric Labs, nor its directors, employees,
          partners, agents, suppliers, or affiliates, be liable for any
          indirect, incidental, special, consequential or punitive damages,
          including without limitation, loss of profits, data, use, goodwill, or
          other intangible losses, resulting from (i) your access to or use of
          or inability to access or use the Service; (ii) any conduct or content
          of any third party on the Service; (iii) any content obtained from the
          Service; and (iv) unauthorized access, use or alteration of your
          transmissions or content, whether based on warranty, contract, tort
          (including negligence) or any other legal theory, whether or not we
          have been informed of the possibility of such damage, and even if a
          remedy set forth herein is found to have failed of its essential
          purpose.
        </p>

        <h2>5. Disclaimer</h2>
        <p>
          Your use of the Service is at your sole risk. The Service is provided
          on an "AS IS" and "AS AVAILABLE" basis. The Service is provided
          without warranties of any kind, whether express or implied, including,
          but not limited to, implied warranties of merchantability, fitness for
          a particular purpose, non-infringement or course of performance.
        </p>

        <h2>6. Governing Law</h2>
        <p>
          These Terms shall be governed and construed in accordance with the
          laws of the Netherlands, without regard to its conflict of law
          provisions.
        </p>
        <p>
          Our failure to enforce any right or provision of these Terms will not
          be considered a waiver of those rights. If any provision of these
          Terms is held to be invalid or unenforceable by a court, the remaining
          provisions of these Terms will remain in effect.
        </p>

        <h2>7. Changes</h2>
        <p>
          We reserve the right, at our sole discretion, to modify or replace
          these Terms at any time. If a revision is material we will try to
          provide at least 30 days notice prior to any new terms taking effect.
          What constitutes a material change will be determined at our sole
          discretion.
        </p>
        <p>
          By continuing to access or use our Service after those revisions
          become effective, you agree to be bound by the revised terms. If you
          do not agree to the new terms, please stop using the Service.
        </p>

        <h2>8. Contact Us</h2>
        <p>
          If you have any questions about these Terms, please contact us at:
        </p>
        <p>
          <a href="mailto:contact@volumetric.io">contact@volumetric.io</a>
        </p>
      </div>
    </div>
  );
};
